import { browser } from '$app/environment';
import { intercomFn } from './intercom';

// This function is run after the logout button has been clicked and just before
// we reload the browser for a clean slate.
export function afterLogout() {
  if (browser) {
    // Intercom
    intercomFn('shutdown');

    // Clear session storage
    sessionStorage.clear();
  }
}
